/**
 * TestModeBanner Component
 * Large banner displayed at the top of /test/:slug routes
 * Indicates that the page is in test mode and not public
 */

export function TestModeBanner() {
  return (
    <div
      className="bg-orange-500 text-white p-4 text-center font-semibold text-lg tracking-wide border-b-4 border-orange-600 sticky top-0 z-50"
      style={{ fontFamily: 'monospace' }}
    >
      <div className="flex items-center justify-center gap-3">
        <span className="text-2xl">⚠️</span>
        <span className="text-xl font-bold">TEST MODE - NOT PUBLIC</span>
        <span className="text-2xl">⚠️</span>
      </div>
    </div>
  );
}
